<template>
    <div class="container">
        <nav>
            <ol class="breadcrumb p-1 my-1">
                <span class="ml-auto mr-2 text-muted">{{getTechResume.data.resume.length}}人</span>
            </ol>
        </nav>
        <div class="row">
            <div class="col-sm-6 mb-2 " v-for="item in getTechResume.data.resume" :key="item.id">
                <!-- 技術者カード -->
                <row :item="item" :class="{'selected-tech':selectedTech == item.id}"></row>
            </div>
        </div>
    </div>
</template>

<script>
    import Row from './Row'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            Row
        },
        data () {
            return {
                selectedTech: ""
            }
        },
        activated () {
            if (this.getRefreshArr['techResume']) {
                this.selectedTech = ""
            }
        },
        computed: {
            ...mapGetters(['getTechResume','getRefreshArr'])
        },
        watch: {
            $route (to, from) {
                this.getSelectedTechLocal()
            }
        },
        methods: {
            getSelectedTechLocal () {
                try {
                    this.selectedTech = localStorage.getItem('selectedTech')
                } catch(e) { }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
